import { Injectable } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  constructor(private titleService: Title, private metaService: Meta) {}

  updateMetaTags(data: {
    title: string;
    description?: string;
    imageUrl?: string;
    url?: string;
  }) {
    // Update page title
    this.titleService.setTitle(data.title);

    // Update or add Open Graph meta tags
    this.updateOrAddTag({ property: 'og:title', content: data.title });

    if (data.description) {
      this.updateOrAddTag({ property: 'og:description', content: data.description });
      this.updateOrAddTag({ name: 'description', content: data.description });
    }

    if (data.imageUrl) {
      this.updateOrAddTag({ property: 'og:image', content: data.imageUrl });
    }

    if (data.url) {
      this.updateOrAddTag({ property: 'og:url', content: data.url });
    }

    // Update or add Twitter meta tags
    this.updateOrAddTag({ name: 'twitter:title', content: data.title });
    this.updateOrAddTag({ name: 'twitter:card', content: 'summary_large_image' });

    if (data.description) {
      this.updateOrAddTag({ name: 'twitter:description', content: data.description });
    }

    if (data.imageUrl) {
      this.updateOrAddTag({ name: 'twitter:image', content: data.imageUrl });
    }
  }

  private updateOrAddTag(tag: { property?: string; name?: string; content: string }) {
    // Check if tag already exists
    const selector = tag.property
      ? `meta[property="${tag.property}"]`
      : `meta[name="${tag.name}"]`;
    const existingTag = document.querySelector(selector);

    if (existingTag) {
      // Update existing tag
      this.metaService.updateTag(tag);
    } else {
      // Add new tag
      this.metaService.addTag(tag);
    }
  }

  // Debug method to check if meta tags are properly set
  debugMetaTags(): void {
    const metaTags = [
      'og:title',
      'og:description',
      'og:image',
      'og:url',
      'twitter:title',
      'twitter:description',
      'twitter:image',
      'twitter:card',
      'description'
    ];

    metaTags.forEach(property => {
      const selector = property.startsWith('og:')
        ? `meta[property="${property}"]`
        : `meta[name="${property}"]`;
      const element = document.querySelector(selector) as HTMLMetaElement;
      console.log(`${property}:`, element?.content || 'NOT FOUND');
    });

    console.log('=== END DEBUG ===');
  }
}
